// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/menu/menu';
import 'snippets/header-menu/header-menu';
import 'snippets/country-switcher/country-switcher';
import 'snippets/_containers/aside/aside';
import 'snippets/algolia-predictive-search/algolia-predictive-search';
import 'snippets/icon/icon';
import 'snippets/cart-dropdown/cart-dropdown';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';

// Styles
import './_header.scss';

// Optional Features
import './header--sticky';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var HEADER_SELECTOR = '.header';
var ANNOUNCEMENT_BAR = '.announcement-bar';
var HAMBURGER_CLASS = 'header__link--menu';
var HAMBURGER_SELECTOR = '.header__link--menu';
var MENU_WRAPPER_SELECTOR = '.header__nav-wrapper';
var MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
var MENU_TRIGGER_SELECTOR = '.header-menu__trigger';
// Classes
var OPEN_CLASS = 'js--is-open';
var CLOSING_CLASS = 'js--is-closing';
var NO_SCROLL_CLASS = 'noscroll';
var MENU_CLOSE_ANIMATION_MS = 250;
var closeMenuTimeout = null;

// -------------------------------------
// Helper functions
// -------------------------------------

// Open the menu
function openMenu(menu) {
  if (closeMenuTimeout) {
    clearTimeout(closeMenuTimeout);
    closeMenuTimeout = null;
  }
  menu.$body.classList.add(NO_SCROLL_CLASS);
  menu.$header.classList.remove(CLOSING_CLASS);
  menu.$header.classList.add(OPEN_CLASS);
  menu.$hamburger.classList.add(OPEN_CLASS);
  menu.$hamburger.setAttribute('aria-expanded', 'true');
}

// Close the menu
function closeMenu(menu) {
  menu.$body.classList.remove(NO_SCROLL_CLASS);
  menu.$hamburger.classList.remove(OPEN_CLASS);
  menu.$hamburger.setAttribute('aria-expanded', 'false');
  removeClassFromElements(menu.$items, OPEN_CLASS);
  setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
  if (!menu.$header.classList.contains(OPEN_CLASS)) return;
  menu.$header.classList.add(CLOSING_CLASS);
  if (closeMenuTimeout) {
    clearTimeout(closeMenuTimeout);
  }
  closeMenuTimeout = setTimeout(function () {
    menu.$header.classList.remove(OPEN_CLASS);
    menu.$header.classList.remove(CLOSING_CLASS);
    closeMenuTimeout = null;
  }, MENU_CLOSE_ANIMATION_MS);
}
function closeSearchAside() {
  var aside = document.getElementById('SearchAside');
  if (aside && typeof aside.closeAside === 'function' && aside.classList.contains('aside--open')) {
    aside.closeAside();
  }
}

// Remove a given class from a list of elements
function removeClassFromElements(elems, className) {
  elems.forEach(function (elem) {
    elem.classList.remove(className);
  });
}

// Set the value of a given attribute for a list of elements
function setAttributeForElements(elems, attribute, value) {
  elems.forEach(function (elem) {
    elem.setAttribute(attribute, value);
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

function setHeaderHeightVar() {
  var header = document.querySelector(HEADER_SELECTOR);
  if (!header) return;
  var update = () => {
    if (header.classList.contains(OPEN_CLASS) || header.classList.contains(CLOSING_CLASS)) {
      return;
    }
    var announcementBar = document.querySelector(ANNOUNCEMENT_BAR);
    // Use getBoundingClientRect so the value is always correct regardless
    // of scroll position: if the bar has scrolled out of view its bottom
    // will be <= 0, so Math.max(0, …) collapses it to zero.
    var visibleAnnouncementHeight = announcementBar ? Math.max(0, announcementBar.getBoundingClientRect().bottom) : 0;
    var totalHeaderHeight = header.offsetHeight + visibleAnnouncementHeight;
    document.documentElement.style.setProperty('--header-height', "".concat(totalHeaderHeight, "px"));
  };
  update();
  window.addEventListener('resize', update, {
    passive: true
  });
  window.addEventListener('scroll', update, {
    passive: true
  });
}
function updateCartCountBadge(count) {
  document.querySelectorAll('.cart-icon__count').forEach(badge => {
    badge.textContent = count;
    badge.classList.toggle('is-hidden', count === 0);
  });
}
iamotaEventHandler.subscribe('cart:modified', function (cart) {
  var _cart$item_count;
  updateCartCountBadge((_cart$item_count = cart === null || cart === void 0 ? void 0 : cart.item_count) !== null && _cart$item_count !== void 0 ? _cart$item_count : 0);
});
document.addEventListener('rebuy:cart.change', function (event) {
  var _event$detail;
  var count = (_event$detail = event.detail) === null || _event$detail === void 0 || (_event$detail = _event$detail.cart) === null || _event$detail === void 0 || (_event$detail = _event$detail.cart) === null || _event$detail === void 0 ? void 0 : _event$detail.item_count;
  if (typeof count === 'number') updateCartCountBadge(count);
});
document.addEventListener('DOMContentLoaded', function () {
  setHeaderHeightVar();
  var menu = {
    $body: document.querySelector('body'),
    $header: document.querySelector(HEADER_SELECTOR),
    $hamburger: document.querySelector(HAMBURGER_SELECTOR),
    $items: document.querySelectorAll(MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(MENU_TRIGGER_SELECTOR)
  };

  // Toggle the mobile menu when the hamburger is clicked
  // Otherwise, close the menu if clicked outside of it
  iamotaEventHandler.subscribe('aside:opened:SearchAside', function () {
    closeMenu(menu);
  });
  menu.$body.addEventListener('click', function (event) {
    var $this = event.target;
    var hamburgerClick = false;
    var hamburger = null;
    if ($this.classList.contains(HAMBURGER_CLASS)) {
      hamburgerClick = true;
      hamburger = $this;
    } else {
      var closestHamburger = $this.closest(HAMBURGER_SELECTOR);
      if (closestHamburger !== null) {
        hamburgerClick = true;
        hamburger = closestHamburger;
      }
    }
    if (hamburgerClick) {
      event.preventDefault();
      event.stopPropagation();
      if (hamburger.classList.contains(OPEN_CLASS)) {
        closeMenu(menu);
      } else {
        closeSearchAside();
        openMenu(menu);
      }
    } else if ($this.closest(MENU_WRAPPER_SELECTOR) === null) {
      closeMenu(menu);
    }
  });
});